<template>
    <span :class="pillClasses">
        <slot></slot>
    </span>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: "default",
            validator: value => {
                const allowedColors = ["default", "primary-green", "primary-red", "alternative", "dark", "light", "green", "red", "yellow", "purple", "blue", "indigo", "pink"];
                return allowedColors.includes(value);
            }
        },
        size: {
            type: String,
            default: "default",
            validator: value => {
                const allowedSizes = ["xs", "sm", "default", "lg"];
                return allowedSizes.includes(value);
            }
        },
        variant: {
            type: String,
            default: "filled",
            validator: value => {
                const allowedVariants = ["filled", "outlined", "soft"];
                return allowedVariants.includes(value);
            }
        }
    },
    computed: {
        pillClasses() {
            let baseClasses = "inline-flex items-center font-medium rounded-md select-none whitespace-nowrap";
            
            // Size classes
            let sizeClasses = '';
            if (this.size === 'xs') sizeClasses = 'text-xs px-2 py-0.5';
            else if (this.size === 'sm') sizeClasses = 'text-xs px-2.5 py-1';
            else if (this.size === 'default') sizeClasses = 'text-sm px-3 py-1.5';
            else if (this.size === 'lg') sizeClasses = 'text-sm px-4 py-2';

            // Color and variant classes
            let colorClasses = '';
            
            if (this.variant === 'filled') {
                colorClasses = {
                    default: "text-white bg-primary-600 dark:bg-primary-600",
                    "primary-green": "text-white bg-primary-green-500 dark:bg-primary-green-500",
                    "primary-red": "text-white bg-primary-red-500 dark:bg-primary-red-500",
                    alternative: "text-gray-900 bg-gray-300 dark:bg-gray-400 dark:text-gray-800",
                    dark: "text-white bg-gray-800 dark:bg-gray-500",
                    light: "text-gray-500 bg-white border border-gray-300 dark:bg-gray-800 dark:text-white dark:border-gray-600",
                    green: "text-white bg-green-500 dark:bg-green-600",
                    red: "text-white bg-red-500 dark:bg-red-600",
                    yellow: "text-white bg-yellow-400 dark:bg-yellow-500",
                    purple: "text-white bg-purple-500 dark:bg-purple-600",
                    blue: "text-white bg-blue-500 dark:bg-blue-600",
                    indigo: "text-white bg-indigo-500 dark:bg-indigo-600",
                    pink: "text-white bg-pink-500 dark:bg-pink-600"
                };
            } else if (this.variant === 'outlined') {
                colorClasses = {
                    default: "text-primary-600 border border-primary-600 dark:text-primary-400 dark:border-primary-400",
                    "primary-green": "text-primary-green-500 border border-primary-green-500 dark:text-primary-green-500 dark:border-primary-green-500",
                    "primary-red": "text-primary-red-500 border border-primary-red-500 dark:text-primary-red-500 dark:border-primary-red-500",
                    alternative: "text-gray-600 border border-gray-300 dark:text-gray-400 dark:border-gray-600",
                    dark: "text-gray-900 border border-gray-800 dark:text-white dark:border-gray-600",
                    light: "text-gray-700 border border-gray-300 dark:text-gray-300 dark:border-gray-600",
                    green: "text-green-600 border border-green-600 dark:text-green-400 dark:border-green-400",
                    red: "text-red-600 border border-red-600 dark:text-red-400 dark:border-red-400",
                    yellow: "text-yellow-600 border border-yellow-600 dark:text-yellow-400 dark:border-yellow-400",
                    purple: "text-purple-600 border border-purple-600 dark:text-purple-400 dark:border-purple-400",
                    blue: "text-blue-600 border border-blue-600 dark:text-blue-400 dark:border-blue-400",
                    indigo: "text-indigo-600 border border-indigo-600 dark:text-indigo-400 dark:border-indigo-400",
                    pink: "text-pink-600 border border-pink-600 dark:text-pink-400 dark:border-pink-400"
                };
            } else if (this.variant === 'soft') {
                colorClasses = {
                    default: "text-primary-800 bg-primary-100 dark:text-primary-200 dark:bg-primary-900",
                    "primary-green": "text-primary-green-700 bg-primary-green-100 dark:text-primary-green-200 dark:bg-primary-green-900",
                    "primary-red": "text-primary-red-700 bg-primary-red-100 dark:text-primary-red-200 dark:bg-primary-red-900",
                    alternative: "text-gray-800 bg-gray-100 dark:text-gray-200 dark:bg-gray-800",
                    dark: "text-gray-900 bg-gray-200 dark:text-gray-100 dark:bg-gray-700",
                    light: "text-gray-700 bg-gray-50 dark:text-gray-300 dark:bg-gray-800",
                    green: "text-green-800 bg-green-100 dark:text-green-200 dark:bg-green-900",
                    red: "text-red-800 bg-red-100 dark:text-red-200 dark:bg-red-900",
                    yellow: "text-yellow-800 bg-yellow-100 dark:text-yellow-200 dark:bg-yellow-900",
                    purple: "text-purple-800 bg-purple-100 dark:text-purple-200 dark:bg-purple-900",
                    blue: "text-blue-800 bg-blue-100 dark:text-blue-200 dark:bg-blue-900",
                    indigo: "text-indigo-800 bg-indigo-100 dark:text-indigo-200 dark:bg-indigo-900",
                    pink: "text-pink-800 bg-pink-100 dark:text-pink-200 dark:bg-pink-900"
                };
            }

            return `${baseClasses} ${sizeClasses} ${colorClasses[this.color]}`;
        }
    }
}
</script>

<style scoped>
</style>
